module.exports = __webpack_public_path__ + "static/media/18-ValdezRojas.a59d231a.png";